export default __webpack_public_path__ + "static/media/Sam.8892d390.jpg";